import React, { useEffect, useMemo, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Axios from "axios";
import { GetClientCaseId } from "../../../../../Functions/General";
import RealPropertyRow from "./components/RealProperty/components/RealPropertyRow";
import CreateProperty from "./components/RealProperty/components/CreateProperty";
import Loading from "../../../../pages/Loading";
import { Box, TableSortLabel } from "@material-ui/core";  


export default function RealProperty(props){
    const mobile                            = window.matchMedia("(max-width: 768px)");
    const [isMobile, setIsMobile]           = useState(mobile.matches);
    const [properties, setProperties]       = useState([]);
    const client_case_id                    = GetClientCaseId();
    const [open, setOpen]                   = useState(false); 
    const [order, setOrder]                 = useState('desc');
    const [orderBy, setOrderBy]             = useState('id');
    const { handleOpen } = props;

    const visuallyHidden = {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    }; 
    
    const mobileHandler = () => {
        const windowHandler = () => {
          setIsMobile(mobile.matches);
          if (!isMobile) {
          }
        };
    
        mobile.addEventListener("change", windowHandler);
        return () => {
          mobile.removeEventListener("change", windowHandler);
        };
    }; 
    
    const headCells = [
      {
        id: 'street_address',
        numeric: false,
        disablePadding: true,
        label: 'Description',
      },
      {
        id: 'value',
        numeric: true,
        disablePadding: true,
        label: 'Value',
      },
      {
        id: 'Debt',
        numeric: true,
        disablePadding: false,
        label: 'Debt',
      },
      {
        id: 'client_sp',
        numeric: true,
        disablePadding: false,
        label: 'Client SP',
      },
      {
        id: 'spouse_sp',
        numeric: true,
        disablePadding: false,
        label: 'Spouse SP',
      },
      {
        id: 'net_value',
        numeric: true,
        disablePadding: false,
        label: 'Net Value',
      },
      {
        id: 'Action',
        numeric: true,
        disablePadding: false,
        label: 'Action',
      },
    ];

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc'; 
    var newValue = sortByProperty(properties, property, isAsc ? 'desc' : 'asc');

    setProperties(newValue);
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  function sortByProperty(arr, prop, order = "asc") {
    return [...arr].sort((a, b) => {
      let valA = a[prop];
      let valB = b[prop];

      // Handle dates
      if (Date.parse(valA) && Date.parse(valB)) {
        valA = new Date(valA);
        valB = new Date(valB);
      }

      if (valA < valB) return order === "asc" ? -1 : 1;
      if (valA > valB) return order === "asc" ? 1 : -1;
      return 0;
    });
  }
      
    function EnhancedTableHead(props) {
      const { order, orderBy, onRequestSort } =
        props;
      const createSortHandler = (property) => (event) => {
        onRequestSort(event, property);
      };

      return (
        <TableHead>
          <TableRow>
            <TableCell padding="checkbox"> 
            </TableCell>
            {headCells.map((headCell) => (
              <TableCell
                className="font-weight-bold text-uppercase text-muted fs-1"
                key={headCell.id}
                align={'left'}
                padding={headCell.disablePadding ? 'none' : 'normal'}
                sortDirection={orderBy === headCell.id ? order : false}
              >
                <TableSortLabel
                  active={orderBy === headCell.id}
                  direction={orderBy === headCell.id ? order : 'asc'}
                  onClick={createSortHandler(headCell.id)}
                >
                  {headCell.label}
                  {orderBy === headCell.id ? (
                    <Box component="span" sx={visuallyHidden}>
                      {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                    </Box>
                  ) : null}
                </TableSortLabel>
              </TableCell>
            ))}
          </TableRow>
        </TableHead>
      );
    }
    const fetch_properties = () => {
        setOpen(true);
        Axios.get("api/estate/real/property/" + client_case_id)
          .then((res) => {
            setProperties(res.data.data);
            setOpen(false);
        })
          .catch((err) => {
            console.log("error", err);
            setOpen(false);
        });
    };
    
    useEffect(() => {
        mobileHandler();
        fetch_properties();
      }, []);
      
      return(
        <>
          <div className="d-flex px-9 align-items-center"> 
            <div className="ml-auto">
                <CreateProperty
                    setProperties={setProperties}
                    properties={properties}
                    client_case_id={client_case_id}
                    handleOpen={handleOpen}
                />
            </div>
          </div> 
            <div className="pb-10 pl-10 pr-10 pt-0">
                <TableContainer component={Paper}>
                <Table aria-label="collapsible table">
                  <EnhancedTableHead  
                    order={order}
                    orderBy={orderBy} 
                    onRequestSort={handleRequestSort}
                    rowCount={properties.length}
                  /> 
                    <TableBody>
                    {properties?.map((row) => (
                        <RealPropertyRow
                        key={row.id}
                        row={row}
                        client_case_id={client_case_id}
                        setProperties={setProperties}
                        />
                    ))}
                    </TableBody>
                </Table>
                </TableContainer>
                {open && <Loading />}
            </div>
        </>
      );
};